import React, { useState, useEffect, useRef, useReducer } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as ideWrapper from "../../lms-shared/ide-wrapper";
import closeIcon from '../../../assests/MaterialLibrary/close-icon.png'
import ProjectActionPopup from './ProjectActionPopup'
import Popup from "./Popup";
import { projectsApi, lessonsApi } from '../../../utils'
import classes from './Project.module.css'
import Moment from 'moment';
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import { ObjectTypeEnum, ObjectTypeNamesEnum } from '../../../models/ObjectTypeEnum';
import SaveTimer from "../../lms-shared/UI/Timer/SaveTimer";
import ForwardLessonBtn from "../MaterialLibrary/ForwardLessonBtn";
import forwardIcon from '../../../assests/toc/forward.png';
import { onKeyDown } from "../../../service";
import DynamicMessage from "../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../../lms-shared/models/DynamicMessageTypeEnum";

const versionsReducer = (versions, action) => {
    switch (action.type) {
        case 'INIT':
            return action.versions
        case 'ADD':
            return [{ ...action.newVersion, isCurrent: true }, ...versions.map(v => ({ ...v, isCurrent: false }))]
        case 'SET_CURRENT':
            return versions.map(v => ({ ...v, isCurrent: action.id === v.id }))
        default:
            throw new Error('should not get there')
    }
}

const Project = ({ iframeHeight }) => {
    const { applicationId, homeUrl } = useSelector(state => state.application);
    const iframeRef = useRef();
    const { studyGroupId, projectId } = useParams();
    const { texts, lang, direction } = useSelector(state => state.translate);
    const uiData = useSelector((state) => state.general.uiData);
    const [showProjectActionPopup, setShowProjectActionPopup] = useState(false)
    const [versions, dispatch] = useReducer(versionsReducer, []);
    const [projectData, setProjectData] = useState({})
    const [messagePopup, setMessagePopup] = useState()
    const [showRobot, setShowRobot] = useState(null);
    const [finish, setFinish] = useState(false)
    const [message, setMessage] = useState()
    const [timerMinutes, setTimerMinutes] = useState(uiData.lastSave)
    const [reload, setReload] = useState(false)
    const navigate = useNavigate()
    const { state } = useLocation()
    const baseDispatch = useDispatch()

    useEffect(() => {
        if (projectData.lessonId)
            getLessonData()
    }, [texts, projectData])

    const showProjectsPopup = () => {
        setShowProjectActionPopup((prevShowPopup) => !prevShowPopup)
    }

    const closePopup = () => {
        setShowProjectActionPopup(false);
    }

    useEffect(() => {
        return () => {
            if (iframeRef.current)
                iframeRef.current.href = "about:blank"
        }
    }, [])

    useEffect(() => {
        if (uiData) {
            if (lang) {
                let data = {
                    id: projectId,
                    studyGroupId: studyGroupId
                }
                projectsApi.projectsFilterPost({ projectFilter: data }, (error, resProjectData, response) => {
                    if (error) {
                        if (localStorage.getItem("reloadCount") === null) {
                            localStorage.setItem("reloadCount", 0)
                        }
                        // baseDispatch(throwApiError({ userMessage: texts.projectsFilterIdError, error: error, statusCode: response?.statusCode, message: "projectsFilterIdPost " + error.message, level: 2, component: "Project", line: 58 }))
                        if (error.status == 403) {
                            baseDispatch(throwApiError({ userMessage: texts.MessageContentProjectsFilterIdNoPermissions, error: error, statusCode: response?.statusCode, message: "projectsFilterIdPost " + error.message, level: 2, component: "Project", line: 62 }))
                        } else {
                            if (Number(localStorage.getItem("reloadCount")) === 0) {
                                localStorage.setItem("reloadCount", 1)
                                baseDispatch(throwApiError({ userMessage: texts.MessageCantLoad, error: error, statusCode: response?.statusCode, message: "projectsFilterIdPost " + error.message, level: 3, component: "Project", line: 65, type: "Warn", showCancel: false, showTitle: false, confirmText: texts.reload }))
                            }
                            else {
                                baseDispatch(throwApiError({
                                    userMessage: texts.MessageCantLoad, error: error, statusCode: response?.statusCode, message: "projectsFilterIdPost " + error.message, level: 2,
                                    component: "Project", line: 65, type: "Warn", showCancel: false, showTitle: false, confirmText: texts.iUnderstand,
                                    showRestore: true
                                }))
                                localStorage.removeItem("reloadCount")
                            }
                        }
                    } else {
                        if (resProjectData && applicationId) {
                            const ideConfig = JSON.parse(resProjectData.ide.additionalConfiguration);
                            const ideUrl = resProjectData.ide.url;
                            //this is hard coded to do fix in the future
                            let IdeLang = resProjectData.ide.lang ? resProjectData.ide.lang : lang
                            if (applicationId === "B71AE893-2769-477A-871A-25B077A26D71" && lang === "ar")
                                IdeLang = "ar"
                            const ideId = resProjectData.ide.id

                            setProjectData({
                                id: resProjectData.id,
                                ideId: resProjectData.ide.id,
                                assessmentName: resProjectData.name,
                                ideUrl: ideUrl,
                                ideId: ideId,
                                ideLang: IdeLang,
                                ideConfig: ideConfig,
                                lessonId: resProjectData.submission?.lessonId,
                                studyGroupId: resProjectData.submission?.studyGroupId,
                                assessmentId: resProjectData.submission?.assessmentId
                            })
                            projectsApi.projectsHistoryIdPost(projectId, (error, resHistorydata, response) => {
                                if (error) {
                                    setFinish(false)
                                    setTimerMinutes(uiData.lastSave)
                                    baseDispatch(throwApiError({ userMessage: texts.projectsFilterIdError, error: error, statusCode: response?.statusCode, message: "projectsHistoryIdPost " + error.message, level: 2, component: "Project", line: 74 }))
                                } else {
                                    if (resHistorydata.length > 0) {
                                        setFinish(false)
                                        setTimerMinutes(uiData.lastSave)
                                        resHistorydata = resHistorydata.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
                                        resHistorydata[0].isCurrent = true;
                                        dispatch({ type: "INIT", versions: resHistorydata })
                                        ideWrapper.load(`${resHistorydata[0].url}`, iframeRef.current, ideUrl, ideConfig, IdeLang, ideId, null, null, resProjectData.id)
                                    }
                                }
                            })
                        }
                    }
                })
            }
        }
    }, [lang, reload, projectId, uiData, applicationId])


    useEffect(() => {
        if (projectData.lessonId)
            getLessonData()
    }, [texts, projectData])

    const getLessonData = async () => {
        if (!projectData.lessonId || projectData.lessonId == "0")
            return;
        let data = {
            id: projectData.lessonId,
            studyGroupId: studyGroupId
        }
        lessonsApi.lessonsFilterPost({ lessonFilter: data }, async (error, resdata, response) => {
            if (error) {
                let txt = texts.lessonsFilterError;
                dispatch(throwApiError({ userMessage: txt, error: error, statusCode: response?.statusCode, message: "lessonsFilterPost " + error.message, level: 2, component: "LessonViewer", line: 23 }))
            }
            else {
                let metaDataJson
                if (response?.body?.materialContentPath && response?.body?.materialContentType == 'SLC') {
                    let notCacheNumber = Math.floor(new Date().getTime());
                    const metaData = await fetch(`${response?.body?.materialContentPath}/meta.json${`?notCacheNumber=${notCacheNumber}`}`);
                    if (metaData.ok) {
                        metaDataJson = await metaData.json();
                    }
                }

                if ((response?.body?.materialContentType === 'SLC' && !metaDataJson?.contents?.length) || (response?.body && !(response?.body.materialContentPath && response?.body.materialContentType && response?.body.materialContentType !== "Pdf")))
                    setShowRobot(false);
                else
                    setShowRobot(true)
            }
        })
    }

    const saveVersion = (callback, setLoader) => {
        /* after save call to load history */
        ideWrapper.requestSaveProject((file, thumbnail, error) => {
            if ((thumbnail && thumbnail?.name === 'blob') || (thumbnail && thumbnail?.name === undefined)) {
                const blobType = thumbnail?.type;
                const extension = blobType?.split('/')[1];
                const newFileName = `thumbnail.${extension}`;
                thumbnail.name = newFileName;
            }
            const data = {
                id: projectId,
                file: file,
                thumbnail: thumbnail,
                studyGroupId: studyGroupId
            }
            setLoader && setLoader(true)
            projectsApi.projectsSavePost(data, (error, resdata, response) => {
                if (error) {
                    baseDispatch(throwApiError({ userMessage: texts.projectsSaveError, error: error, statusCode: response?.statusCode, message: "projectsSavePost " + error.message, level: 2, component: "Project", line: 107 }))
                }
                else {
                    dispatch({
                        type: "ADD",
                        newVersion: {
                            "id": resdata.id,
                            "url": resdata.url,
                            "createdDate": resdata.createdDate,
                        }
                    })
                    callback && callback()
                    setFinish(false)
                    setTimerMinutes(uiData.lastSave)
                    ideWrapper.showToastMesssage("green", "הפרויקט נשמר בהצלחה")
                }
                setLoader && setLoader(false)
            })
        })
    }

    const loadFunc = (versionId) => {
        let index = versions.findIndex(v => v.id === versionId)
        dispatch({ type: 'SET_CURRENT', id: versionId })
        ideWrapper.load(`${versions[index].url}`, iframeRef.current, projectData.ideUrl, projectData.ideConfig, projectData.ideLang, projectData.ideId)
    }

    const saveCopyVersion = (setLoader) => {
        ideWrapper.requestSaveProject((file, error) => {
            const data = {
                id: projectId,
                file: file,
                refObjectType: ObjectTypeNamesEnum.Application,
                refObjectId: applicationId
            }
            setLoader && setLoader(true)
            projectsApi.projectsDuplicatePost(data, (error, resdata, response) => {
                if (error) {
                    baseDispatch(throwApiError({ userMessage: texts.projectsDuplicateError, error: error, statusCode: response?.statusCode, message: "projectsDuplicatePost " + error.message, level: 2, component: "Project", line: 138 }))
                }
                else {
                    ideWrapper.showToastMesssage("green", "הפרויקט נשמר בהצלחה")

                }
                setLoader && setLoader(false)
            })
        })
    }

    const goBack = () => {
        setMessagePopup(null)
        if (projectData.ideId == 1)
            state?.prevPath ? window.location.href = `${state.prevPath}` : window.location.href = `${homeUrl}`;
        else
            state?.prevPath ? window.location.href = state.prevPath : navigate(homeUrl)
    }

    const saveAndGoBack = () => {
        saveVersion(goBack)
    }

    const goBackConfirm = () => {
        ideWrapper.requestChangesProject((changed) => {
            if (changed == true) {
                setMessagePopup(<DynamicMessage
                    type={DynamicMessageTypeEnum.Warn}
                    title={texts.messageContentSaveProjectContent}
                    cancelFunc={() => setMessagePopup(null)}
                    confirmText={texts.save}
                    confirmFunc={() => saveAndGoBack()}
                    otherText={texts.exitWithoutSaving}
                    otherFunc={goBack}
                    customWidth='430px' />)
            }
            else {
                setMessagePopup(<DynamicMessage
                    type={DynamicMessageTypeEnum.Warn}
                    title={texts.exitIde}
                    cancelFunc={() => setMessagePopup(null)}
                    confirmText={texts.exit}
                    confirmFunc={goBack} />);
            }
        })
    }

    return (
        <>
            {message}
            {messagePopup}
            <div className={`${classes[direction]} ${classes.Header}`}>
                <div>
                    <div className={classes.ProjectsPopupContainer}>
                        <div className={classes.ProjectsPopup} onClick={() => showProjectsPopup()} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => showProjectsPopup())}>
                            {versions && versions.find(v => v.isCurrent) && versions.find(v => v.isCurrent).createdDate && <div className={classes.AssessmentName}>
                                <div className={classes.AssessmentNameText}>{projectData.assessmentName}</div>
                                <div className={classes.RecentlySaved} >({texts.recentlySaved} {Moment(versions.find(v => v.isCurrent).createdDate).format('HH:mm DD/MM')})</div>
                            </div>}
                        </div>
                        <div className={classes.Popup} >
                            {showProjectActionPopup && <ProjectActionPopup versions={versions}
                                saveFunc={(setLoader) => { saveVersion(null, setLoader); setFinish(null) }} saveCopyVersion={(setLoader) => { saveCopyVersion(setLoader); setFinish(null) }} loadFunc={loadFunc}
                                closePopup={closePopup} assessmentName={projectData.assessmentName} setShowProjectActionPopup={setShowProjectActionPopup} />}
                        </div>
                    </div>
                </div>
                <div className={classes.FowardProject}>
                    <ForwardLessonBtn ViewAnimate={true} ViewText={texts.copyLinkToCode} setMessage={setMessage} data={{ id: projectData.id, name: projectData.assessmentName }} type={ObjectTypeEnum.Project} icon={forwardIcon} iconText={texts.sendProject} />
                </div>
                <div><SaveTimer initialMinutes={timerMinutes} initialFinish={finish} setFinish={setFinish} initialHours={0} confirmFunc={() => saveVersion()}></SaveTimer></div>
                <p src={closeIcon} alt={closeIcon} className={classes.Close} onClick={() => goBackConfirm()} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => goBackConfirm())}>ⓧ</p>
            </div>
            {projectData.lessonId && showRobot && <Popup lessonId={projectData.lessonId} studyGroupId={projectData.studyGroupId} saveProjectCallback={saveVersion} selectedAssessmentId={projectData.assessmentId} />}
            <iframe allow="camera *;microphone *" className={classes.Iframe} frameBorder={0} ref={iframeRef} title='bla' style={{ height: iframeHeight }}></iframe>
        </>
    )
};

export default Project;